import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window to top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    
    // Also scroll any main content areas that might be scrollable
    const mainElements = document.querySelectorAll('main');
    mainElements.forEach(el => {
      el.scrollTop = 0;
    });
    
    // Try with a small delay for dynamic content
    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      mainElements.forEach(el => {
        el.scrollTop = 0;
      });
    }, 100);
    
    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}
